import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="report-download"
export default class extends Controller {
  static targets = ["wrapper"]

  connect() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.show(this.wrapperTarget)
      })
    })
  }

  show(target) {
    target.classList.remove("hidden")

    requestAnimationFrame(() => {
      target.classList.remove("opacity-0", "scale-95", "pointer-events-none")
      target.classList.add("opacity-100", "scale-100")
    })
  }
}
